<template>
	<div>
		<button class="block w-full" @click="toggleAccordionItem()">
			<slot name="button" v-bind:open="isOpen"> Insert default </slot>
		</button>
		<div v-show="isOpen">
			<slot> </slot>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isOpen: false,
		};
	},
	methods: {
		toggleAccordionItem() {
			this.isOpen = !this.isOpen;
		},
	},
};
</script>
